import { render, staticRenderFns } from "./portSelect.vue?vue&type=template&id=01cd1186&scoped=true&"
import script from "./portSelect.vue?vue&type=script&lang=js&"
export * from "./portSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cd1186",
  null
  
)

export default component.exports